export default __webpack_public_path__ + "media/images/react_icons/user-43d2b78d345817f0eb0bb7a9355e06cd.svg";